import loadable from '@loadable/component';

export const ActionsCentersLoadable = loadable(
  () => import('./ActionsCenters').catch(/* istanbul ignore next */ () => ({ default: () => null })),
  { ssr: false },
);
